import Component from "../../lib/component";
import {getRandomAvatarElement} from "../../helpers/avatar";
import {randItem} from "../../helpers/array";
import {isImgLoaded} from "../../helpers/img";

export const AvatarConfig = {
    componentTypeKey: 'Avatar',
    baseHtmlClass: 'avatar',
    selector: '.avatar',

    imgLoadedClassModifier: 'loaded',
    imgUnloadedClassModifier: 'unloaded',
    hasEmojiClassModifier: 'has_emoji',

    datasetConfigKey: 'avatar__config',

    personIdentifierDatasetConfigKey: 'person_identifier',
    personInitialsDatasetConfigKey: 'person_initials',
    countryFlagUrlDatasetConfigKey: 'country_flag_url',

    userTypeDatasetConfigKey: 'user_type',
    avatarTypeDatasetConfigKey: 'avatar_type',
    imageUrlDatasetConfigKey: 'image_url',
    avatarTitleDatasetConfigKey: 'avatar_title',
    placeholderImageUrlDatasetConfigKey: 'placeholder_image_url',
    tintColorDatasetConfigKey: 'tint_color',


    linerHtmlClass: 'avatar__liner',
    linerSelector: '.avatar__liner',

    imageHtmlClass: 'avatar__img',
    imgSelector: '.avatar__img',

    emojiHtmlClass: 'avatar__emoji',

    randomAvatarSelector: '.avatar__random',
};

export class Avatar extends Component {

    static get config() {
        return AvatarConfig;
    }

    constructor(id_or_element, options={}) {
        super({
            element: id_or_element,
            config: AvatarConfig
        });

        this.setDatasetConfig(AvatarConfig.datasetConfigKey);
        this.personIdentifier = this.getDatasetConfigValue(AvatarConfig.personIdentifierDatasetConfigKey);
        this.personInitials = this.getDatasetConfigValue(AvatarConfig.personInitialsDatasetConfigKey);
        this.countryFlagUrl = this.getDatasetConfigValue(AvatarConfig.countryFlagUrlDatasetConfigKey);
        this.userType = this.getDatasetConfigValue(AvatarConfig.userTypeDatasetConfigKey);
        this.avatarType = this.getDatasetConfigValue(AvatarConfig.avatarTypeDatasetConfigKey);
        this.imageUrl = this.getDatasetConfigValue(AvatarConfig.imageUrlDatasetConfigKey);
        this.avatarTitle = this.getDatasetConfigValue(AvatarConfig.avatarTitleDatasetConfigKey);
        this.placeholderImageUrl = this.getDatasetConfigValue(AvatarConfig.placeholderImageUrlDatasetConfigKey);
        this.tintColor = this.getDatasetConfigValue(AvatarConfig.tintColorDatasetConfigKey);

        this.randomAvatarElement = null;

        this.addHtmlClassState(this.userType);
        this.addHtmlClassState(this.avatarType);

        this.element.innerHTML = setInitialContent(this.countryFlagUrl, this.placeholderImageUrl, this.avatarTitle);

        this.emoji = options.emoji || [];
        this.emojiElement = createEmojiElement(this.element);

        this.linerElement = this.element.querySelector(AvatarConfig.linerSelector);

        this.isImgLoaded = null; // Is the Gravatar image loaded (otherwise it could be 404)
        this.imgElement = this.element.querySelector(AvatarConfig.imgSelector);
        if (this.imgElement) {
            this.isImgLoaded = isImgLoaded(this.imgElement);
            this.imgElement.addEventListener('error', this.handleImgError.bind(this));
            this.imgElement.addEventListener('load', this.handleImgLoad.bind(this));
            this.imgElement.src = this.imageUrl;
        }

        this.render();
    }

    handleImgError() {
        this.isImgLoaded = false;
        this.render();
    }

    handleImgLoad() {
        this.isImgLoaded = isImgLoaded(this.imgElement);
        this.render();
    }

    render() {
        this.removeRandomAvatars();

        if (!this.isImgLoaded) {
            if (!this.randomAvatarElement) this.randomAvatarElement = getRandomAvatarElement(this.personIdentifier, this.personInitials);
            this.addRandomAvatar();
        }

        this.conditionallySetHtmlClassState(this.hasEmoji(), AvatarConfig.hasEmojiClassModifier);
        this.renderEmojiElement();

        if (this.tintColor) this.element.style.setProperty('--_avatar__tint_color', this.tintColor);

        this.swapHtmlClassStates(!!this.isImgLoaded, AvatarConfig.imgLoadedClassModifier, AvatarConfig.imgUnloadedClassModifier);
    }

    renderEmojiElement() {
        if (!this.emojiElement) return;

        if (this.hasEmoji()) {
           this.emojiElement.innerHTML = `<span>${ randItem(this.emoji) }</span>`;
        } else {
            this.emojiElement.innerHTML = ``;
        }
    }

    addRandomAvatar() {
        if (!this.linerElement) return;
        if (!this.randomAvatarElement) return;
        this.linerElement.prepend(this.randomAvatarElement);
    }

    removeRandomAvatars() {
        this.element.querySelectorAll(AvatarConfig.randomAvatarSelector).forEach((element) => {
            element.parentElement.removeChild(element);
        });
    }

    setEmoji(emoji) {
        this.emoji = emoji;
        this.render();
    }

    hasEmoji() {
        if (typeof this.emoji == 'undefined' || this.emoji === null) return false;
        return (this.emoji.length > 0 );
    }

}

function createEmojiElement(parentElement) {
    let element = Component.createElement(AvatarConfig.emojiHtmlClass);
    parentElement.append(element);
    return element;
}

function setInitialContent(countryFlagUrl, placeholderImageUrl, avatarTitle) {
  let countryFlagImage = '';
  const placeholderImg = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+8aFQAAAAASUVORK5CYII=" // 1x1 pixel transparent image
  if (!!countryFlagUrl) countryFlagImage = `<div class="avatar__flag"><div class="avatar__flag__liner"><img src="${countryFlagUrl}" alt="" /></div></div>`;

  return `
${countryFlagImage}
<div class="${Avatar.config.linerHtmlClass}">
  <img class="${Avatar.config.imageHtmlClass}" src="${placeholderImageUrl || placeholderImg}" title="${avatarTitle}" alt="${avatarTitle}" style="width: 100%;" loading="lazy" />
</div>
`;
}
